import {
  useEffect,
  useState,
} from "react";

export default function useMatrixRooms(
  client
) {
  const [rooms, setRooms] =
    useState([]);

  const [selectedRoomId, setSelectedRoomId] =
    useState(null);

  useEffect(() => {
    if (!client) {
      setRooms([]);
      setSelectedRoomId(null);
      return;
    }

    const matrixRooms =
      client.getRooms();

    setRooms(matrixRooms);

    if (matrixRooms.length > 0) {
      setSelectedRoomId(
        matrixRooms[0].roomId
      );
    }

    function handleRoomUpdate() {
      const updatedRooms =
        client.getRooms();

      setRooms(updatedRooms);
    }

    client.on(
      "Room.timeline",
      handleRoomUpdate
    );

    return () => {
      client.removeListener(
        "Room.timeline",
        handleRoomUpdate
      );
    };
  }, [client]);

  return {
    rooms,
    selectedRoomId,
    setSelectedRoomId,
  };
}